import React, {Fragment} from 'react'
import styles from './TRouteSidePanel.scss'
import {ROLE_SIDE_PANEL} from 'common/layouts/ThreePanelLayout'
import {StickyHeaderSidePanel} from 'common/layouts/ThreePanelLayout/StickyHeaderSidePanel'
import {featureTypes} from 'common/MapV2/featureTypes'
import {TRouteSidePanelActions} from './TRouteSidePanelActions'
import {formatText} from 'lib/textUtils'
import {showModal} from 'lib/modalUtils'
import {EDIT_TROUTE_MODAL} from 'common/modals/EditTRouteModal'
import {TRouteMeta} from './TRouteMeta'
import {TRoutePhotos} from './TRoutePhotos'
import {TRouteCues} from './TRouteCues'
import {TRouteHills} from './TRouteHills'
import {TRouteComments} from './TRouteComments'
import {TRouteSegments} from './TRouteSegments'
import {SignupPrompt} from './SignupPrompt'
import {NavigationInfo} from './NavigationInfo'
// This should be un-nested if we're rendering Trip metrics in
// a different spot than Route metrics, since the TRouteMetrics component
// is useless in this case. But since I'm not sure what the final say will
// be on that, waiting to refactor until hamking have finished design tweakages.
import {TripMetrics} from './TRouteMetrics/TripMetrics'
import {TripLaps} from './TripLaps'
import {Metrics as RouteMetrics} from 'features/routes/RouteShowPage/SidePanel/SidePanel.js'
import {CollapseMap} from './CollapseMap'
import moment from 'moment'

class ScrollingHeader extends React.PureComponent {
  render () {
    const {troute, objectType} = this.props
    const allowInlineEdits = troute.permissions && troute.permissions.canBeModified && !troute.locked
    const showEditModal = () => showModal(EDIT_TROUTE_MODAL, {troute, objectType})

    return (
      <div className={styles.ScrollingHeader}>
        <TRouteSidePanelActions troute={troute} objectType={objectType} />
        <div className={styles.titleAuthor}>
          {/* TODO - UI hint and cursor style for quick editing */}
          <h1 onClick={allowInlineEdits && showEditModal}>{troute.name}</h1>
          <div className={styles.byline}>
            By <a href={troute.bylinePath}>{troute.bylineName}</a>
          </div>
          {troute.departedAt && <div className={styles.departedAt}>{moment(troute.departedAt).format('MMMM D, YYYY, h:mm a')}</div>}
        </div>
      </div>
    )
  }
}

class StickyHeader extends React.PureComponent {
  render () {
    const {troute, objectType} = this.props

    return (
      <div className={styles.StickyHeader}>
        {troute.name}
        <TRouteSidePanelActions mini troute={troute} objectType={objectType} />
      </div>
    )
  }
}

export class TRouteSidePanel extends React.PureComponent {
  static role = ROLE_SIDE_PANEL

  render () {
    const {
      objectType,
      onTriggerFileBrowser,
      pendingPhotoUploads,
      troute,
      troutePhotos,
      onPhotoDeleted,
      onFeatureHovered,
      onFeatureSelected,
      currentUser,
      selectedFeature
    } = this.props

    const reallyCanEdit = troute.permissions && troute.permissions.canBeModified && !troute.locked

    // FIXME: when we move RSP to TRSP, we can update RouteMetrics to be TRouteMetrics and directly use
    // the onFeatureHovered approach that we are using in TripMetrics
    const rspCompatibleOnPointHighlighted = (highlightedPoint, label) => {
      if (highlightedPoint) {
        const {index} = highlightedPoint
        onFeatureHovered({
          type: featureTypes.POINT_METRIC,
          data: {highlightPoint: {trackPoint: troute.trackPoints[index], index}, label}
        })
      } else {
        onFeatureHovered(null)
      }
    }

    return (
      <StickyHeaderSidePanel
        stickyHeader={<StickyHeader troute={troute} objectType={objectType} />}
        scrollingHeader={<ScrollingHeader troute={troute} objectType={objectType} />}>
        <div className={styles.TRouteSidePanel}>
          <RouteMetrics troute={troute} objectType={objectType} onPointHighlighted={rspCompatibleOnPointHighlighted} />
          <CollapseMap troute={troute} />
          <div className={styles.padWrap}>
            {troute.description && troute.description.trim() !== '' && (
              <Fragment>
                <div className={styles.description}>
                  {formatText(troute.description)}
                  {reallyCanEdit && <p>
                    <a className={styles.editLink}
                      onClick={() => showModal(EDIT_TROUTE_MODAL, {troute, objectType})}>Edit</a>
                  </p>}
                </div>
                <hr />
              </Fragment>
            )}
            <TRouteMeta troute={troute} objectType={objectType} editable={reallyCanEdit} />
            <hr />
            {troutePhotos && <TRoutePhotos
              editable={reallyCanEdit}
              objectType={objectType}
              troute={troute}
              onTriggerFileBrowser={onTriggerFileBrowser}
              pendingPhotoUploads={pendingPhotoUploads}
              photos={troutePhotos}
              onPhotoDeleted={onPhotoDeleted} />}
            {objectType === 'trip' && troute.navId && <NavigationInfo troute={troute} objectType={objectType} />}
            {objectType === 'trip' && !currentUser.id && <SignupPrompt />}
            {objectType === 'trip' && <TripMetrics
              trip={troute}
              onFeatureHovered={onFeatureHovered}
              selectedFeature={selectedFeature} />}
            {objectType === 'route' && <TRouteCues
              troute={troute}
              onFeatureHovered={onFeatureHovered}
              onFeatureSelected={onFeatureSelected} />}
            <TRouteSegments
              objectType={objectType}
              troute={troute}
              onFeatureHovered={onFeatureHovered}
              onFeatureSelected={onFeatureSelected} />
            {objectType === 'trip' && <TripLaps trip={troute} />}
            <TRouteHills
              troute={troute}
              onFeatureHovered={onFeatureHovered}
              onFeatureSelected={onFeatureSelected} />
            <TRouteComments troute={troute} objectType={objectType} />
          </div>
        </div>
      </StickyHeaderSidePanel>
    )
  }
}
